export const FACILITY_MAP = {
    ANM: "3100",
    PHC: "3200",
    CHC: "3300",
    DH: "3400",
    TCC: "3500"
};

export const FACILITY_LABEL_MAP = {
    3100: "ANM",
    3200: "PHC",
    3300: "CHC",
    3400: "DH",
    3500: "TCC"
};

export const getFacilityLabel = (facilityId) => {
    if (!facilityId) return "";
    const id = Number(facilityId);
    if (!isNaN(id) && FACILITY_LABEL_MAP[id]) {
        return FACILITY_LABEL_MAP[id];
    }
    return String(facilityId);
};

export const getLocationFacilityDetails = (loggedData = {}) => {
    let location_type = loggedData?.facilityType || '';
    const facilityTypeId = Number(loggedData?.facilityTypeId || loggedData?.facilityId);

    if (!location_type && facilityTypeId) {
        if (facilityTypeId === 3200) location_type = 'PHC';
        else if (facilityTypeId === 3300) location_type = 'CHC';
        else if (facilityTypeId === 3400) location_type = 'DH';
        else if (facilityTypeId === 3500) location_type = 'TERTIARY';
    }

    const normType = String(location_type || '').toUpperCase();

    if (normType === 'CHC' || facilityTypeId === 3300) {
        return {
            location_type: 'CHC',
            facilityId: 3300,
            referFurtherToFacility: [
                { id: 3400, name: 'DH' },
                { id: 3500, name: 'TCC' }
            ],
            userToList: [
                { facilityId: 3300, name: 'Self' },
                { facilityId: 3200, name: 'PHC' },
                { facilityId: 3100, name: 'ANM' }
            ]
        };
    } else if (normType === 'DH' || facilityTypeId === 3400) {
        return {
            location_type: 'DH',
            facilityId: 3400,
            referFurtherToFacility: [
                { id: 3500, name: 'TCC' }
            ],
            userToList: [
                { facilityId: 3400, name: 'Self' },
                { facilityId: 3300, name: 'CHC' },
                { facilityId: 3200, name: 'PHC' },
                { facilityId: 3100, name: 'ANM' }
            ]
        };
    } else if (normType === 'TERTIARY' || normType === 'TCC' || facilityTypeId === 3500) {
        return {
            location_type: 'TERTIARY',
            facilityId: 3500,
            referFurtherToFacility: [],
            userToList: [
                { facilityId: 3500, name: 'Self' },
                { facilityId: 3400, name: 'DH' },
                { facilityId: 3300, name: 'CHC' },
                { facilityId: 3200, name: 'PHC' },
                { facilityId: 3100, name: 'ANM' }
            ]
        };
    } else {
        // Default / PHC
        return {
            location_type: 'PHC',
            facilityId: 3200,
            referFurtherToFacility: [
                { id: 3300, name: 'CHC' },
                { id: 3400, name: 'DH' },
                { id: 3500, name: 'TCC' }
            ],
            userToList: [
                { facilityId: 3200, name: 'Self' },
                { facilityId: 3100, name: 'ANM' }
            ]
        };
    }
};

